import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type VerificationStatusResponse = {
  identityVerificationStatus: string
  acceptedTerms: boolean
}

type UseVerificationStatusParams = {
  enabled?: boolean
}

export function useVerificationStatus({ enabled = true }: UseVerificationStatusParams = {}) {
  return useQuery<VerificationStatusResponse>({
    queryKey: ["VerificationStatus"],
    enabled,
    queryFn: async () => {
      const response = await fetcher(
        "/Verification/Status",
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
  })
}
